import React, { useMemo, useRef } from 'react';
import { useInViewOnce } from './useInViewOnce';

function cn(...parts) {
  return parts.filter(Boolean).join(' ');
}

export default function LandingSection({
  id,
  eyebrow,
  title,
  subtitle,
  align = 'left',
  children,
  className,
  innerClassName,
  withTopDivider = false,
}) {
  const ref = useRef(null);
  const inView = useInViewOnce(ref);

  const headingAlign = align === 'center' ? 'text-center' : 'text-left';
  const contentAlign = align === 'center' ? 'mx-auto text-center' : '';

  const header = useMemo(() => {
    if (!eyebrow && !title && !subtitle) return null;
    return (
      <header className={cn('max-w-2xl', contentAlign)}>
        {eyebrow && (
          <div className="inline-flex items-center gap-2 rounded-full border border-white/10 bg-white/5 px-3 py-1 text-xs text-white/60">
            <span className="h-1.5 w-1.5 rounded-full bg-blue-400" />
            {eyebrow}
          </div>
        )}
        {title && (
          <h2 className={cn('mt-4 text-xl font-semibold text-white sm:text-2xl', headingAlign)}>
            {title}
          </h2>
        )}
        {subtitle && (
          <p className={cn('mt-2 text-sm leading-relaxed text-white/55', headingAlign)}>
            {subtitle}
          </p>
        )}
      </header>
    );
  }, [contentAlign, eyebrow, headingAlign, subtitle, title]);

  return (
    <section
      id={id}
      ref={ref}
      className={cn(
        'mt-14 scroll-mt-24',
        withTopDivider && 'border-t border-white/10 pt-12',
        'transition-all duration-700 will-change-transform',
        inView ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-4',
        className,
      )}
    >
      {header}
      <div className={cn('mt-6', innerClassName)}>
        {children}
      </div>
    </section>
  );
}

